import { SignUp } from '@clerk/react'
import { AuthLayout } from '../../ui/AuthLayout.js'

/**
 * Creating an identity.
 *
 * Only an identity: the organisation comes next, on a screen of this
 * product's own, because an organisation is a tenant and tenants are not
 * something an identity provider knows about. The provider owns the address,
 * the password and the confirmation code; nothing here sees any of them.
 *
 * Finishing here leaves somebody signed in with no place in the product, which
 * `useSession` reads as `needs-organisation` and answers with the form that
 * makes one.
 */
export function SignUpPage() {
  return (
    <AuthLayout>
      <SignUp
        routing="path"
        path="/signup"
        signInUrl="/signin"
        fallbackRedirectUrl="/"
        appearance={{ elements: { rootBox: 'w-full', cardBox: 'w-full shadow-none' } }}
      />
    </AuthLayout>
  )
}
